var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "placeorderdetail",
        minHeight: 200,
        minWidth: 200,
        maxWidth: 1300,
        scrollable: true,
        adaptive: true,
        reset: true,
        height: "auto"
      },
      on: { "before-open": _vm.beforeOpen }
    },
    [
      _c("div", { staticClass: "modal--container" }, [
        _c("div", { staticClass: "d-flex justify-content-between pt-3" }, [
          _c("h4", [_vm._v("Place Order")]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "close",
              attrs: { type: "button" },
              on: { click: _vm.closeModal }
            },
            [
              _c(
                "span",
                { attrs: { "aria-hidden": "true" } },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "times", size: "1x" }
                  })
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column" }, [
          _c("div", { staticClass: "d-flex mt-4" }, [
            _c("div", { staticClass: "d-flex flex-column col-6" }, [
              _c(
                "table",
                { staticClass: "table mt-3 table-bordered table-striped" },
                [
                  _c("tbody", [
                    _c("tr", [
                      _c("td", { attrs: { width: "50%" } }, [
                        _vm._v("Order Total")
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("$" + _vm._s(_vm.orderTotal))])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("Subsidized Total")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("$" + _vm._s(_vm.subsidizedSubtotal))])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("Need to Pay")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("$" + _vm._s(_vm.needToPay))])
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.needToPay > _vm.subsidizedSubtotal
                ? _c("span", { staticClass: "total-increased mt-1" }, [
                    _vm._v("*Food total exceeds remaining user subsidy.")
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex flex-column mt-5" }, [
            _c("span", { staticClass: "caption mb-2" }, [
              _vm._v("Choose Payment Method")
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "py-1" }, [
                _c("div", { staticClass: "mb-2 d-flex align-items-center" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.picked,
                        expression: "picked"
                      }
                    ],
                    staticClass: "mr-2",
                    attrs: {
                      type: "radio",
                      id: "personal",
                      value: "credit_card"
                    },
                    domProps: { checked: _vm._q(_vm.picked, "credit_card") },
                    on: {
                      change: function($event) {
                        _vm.picked = "credit_card"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "personal" } }, [
                    _vm._v("Pay with credit card")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mt-2 d-flex align-items-center" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.picked,
                        expression: "picked"
                      }
                    ],
                    staticClass: "mr-2",
                    attrs: {
                      type: "radio",
                      id: "office",
                      value: "paid_by_invoice"
                    },
                    domProps: {
                      checked: _vm._q(_vm.picked, "paid_by_invoice")
                    },
                    on: {
                      change: function($event) {
                        _vm.picked = "paid_by_invoice"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "office" } }, [
                    _vm._v("Override subsidy and bill to account invoice")
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.picked == "credit_card"
            ? _c(
                "div",
                { staticClass: "d-flex flex-column mt-4" },
                [
                  _c("span", { staticClass: "caption" }, [
                    _vm._v("Choose card to complete Payment")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "mx-5 note mb-4" }, [
                    _vm._v(
                      "\n          Please note that choosing a card saved on a user’s profile means\n          they will be charged on any saved credit cards, including personal\n          cards\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.employeeCards, function(card) {
                    return _c(
                      "div",
                      { key: card.card_id, staticClass: "credit-card" },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.card_id,
                                  expression: "card_id"
                                }
                              ],
                              staticClass: "mr-3",
                              attrs: { type: "radio", id: card.card_id },
                              domProps: {
                                value: card.card_id,
                                checked: _vm._q(_vm.card_id, card.card_id)
                              },
                              on: {
                                change: function($event) {
                                  _vm.card_id = card.card_id
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    card.card_type == "VI"
                                      ? _c("img", {
                                          staticClass: "card-icon",
                                          attrs: {
                                            src: require("@/assets/img/visa-card.png"),
                                            alt: "visa card",
                                            "data-retina": "true"
                                          }
                                        })
                                      : _c("img", {
                                          staticClass: "card-icon",
                                          attrs: {
                                            src: require("@/assets/img/card-icon.png"),
                                            alt: "card",
                                            "data-retina": "true"
                                          }
                                        }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex flex-column ml-2"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "card-type" },
                                          [_vm._v(_vm._s(card.card_type))]
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "card-no" }, [
                                          _vm._v(
                                            "**** **** ****\n                    " +
                                              _vm._s(
                                                card.number.substring(
                                                  card.number.length - 4
                                                )
                                              )
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row justify-content-end mt-3" }, [
            _c("div", { staticClass: "my-1 mr-3 my-md-0" }, [
              _c(
                "button",
                {
                  staticClass: "other_btn gray-hover",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.closeModal.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("\n            Close\n          ")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "my-1 my-md-0" }, [
              _c(
                "button",
                {
                  staticClass: "save_btn hover-dark",
                  attrs: { type: "submit" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.pay()
                    }
                  }
                },
                [_vm._v("\n            Place Order\n          ")]
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a94be99", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a94be99","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OfficeAdmin/PlaceOrder/PlaceOrderDetailModal.vue
// module id = null
// module chunks = 